import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://web-production-120c.up.railway.app';
const USD_TO_AED = 3.67;

const TIERS = [
  {
    id: 'core',
    name: 'Core',
    monthly_usd: 99,
    annual_usd: 990,
    tagline: 'Essential protection for busy executives',
    features: [
      'Dark web monitoring — email addresses',
      'Monthly digital exposure assessment',
      'Concierge chat — AI-powered response',
      '9 incident response playbooks',
      'Monthly security briefing',
      'Secure portal with 2FA login',
    ],
    notIncluded: [
      'Travel security advisory',
      'Social media impersonation sweep',
      'Family member coverage',
      'Dedicated advisor',
    ]
  },
  {
    id: 'elite',
    name: 'Elite',
    monthly_usd: 249,
    annual_usd: 2490,
    tagline: 'Comprehensive protection for high-profile individuals',
    popular: true,
    features: [
      'Everything in Core',
      'Weekly automated monitoring',
      'Priority response — under 30 minutes',
      'Travel security advisory',
      'Social media impersonation sweep',
      'One family member covered',
      'Device security setup guidance',
      'Bi-weekly threat intelligence briefing',
    ],
    notIncluded: [
      'Dedicated human advisor',
      'Unlimited family members',
      'Monthly advisor briefing call',
    ]
  },
  {
    id: 'black',
    name: 'Black',
    monthly_usd: 499,
    annual_usd: 4990,
    tagline: 'White-glove security for executives and their families',
    features: [
      'Everything in Elite',
      'Dedicated human advisor',
      'Real-time breach alerts',
      'Unlimited family members covered',
      'Monthly advisor briefing call',
      'Emergency priority line',
      'Corporate domain monitoring',
      'Custom monitoring configuration',
    ],
    notIncluded: []
  }
];

const SECTORS = ['Real estate', 'Finance', 'Technology', 'Energy', 'Government', 'Healthcare', 'Legal', 'Other'];

const s = {
  page: { minHeight: '100vh', background: '#08080f', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" },
  header: { background: '#0d0d16', borderBottom: '0.5px solid #1c1c30', padding: '20px 24px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  logo: { display: 'flex', alignItems: 'center', gap: 10, fontSize: 15, fontWeight: 500, letterSpacing: '0.1em', color: '#c8b48a' },
  loginLink: { fontSize: 12, color: '#7a7888', cursor: 'pointer', background: 'none', border: '0.5px solid #1c1c30', borderRadius: 6, padding: '6px 14px' },
  hero: { textAlign: 'center', padding: '48px 24px 40px' },
  heroTitle: { fontSize: 28, fontWeight: 500, color: '#d4ccc0', marginBottom: 10, letterSpacing: '-0.01em' },
  heroSub: { fontSize: 14, color: '#7a7888', maxWidth: 480, margin: '0 auto', lineHeight: 1.7 },
  billingToggle: { display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginTop: 28 },
  toggleBtn: { fontSize: 12, padding: '7px 18px', borderRadius: 20, cursor: 'pointer', border: '0.5px solid #1c1c30', transition: 'all 0.15s' },
  saveBadge: { fontSize: 10, background: '#1a2a10', color: '#608040', border: '0.5px solid #608040', borderRadius: 10, padding: '2px 8px', marginLeft: 6 },
  tiers: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16, padding: '0 24px 40px', maxWidth: 1000, margin: '0 auto' },
  tierCard: { background: '#0d0d16', border: '0.5px solid #1c1c30', borderRadius: 14, padding: '24px', display: 'flex', flexDirection: 'column', transition: 'border-color 0.15s' },
  tierCardPop: { border: '1.5px solid #c8b48a' },
  popularBadge: { fontSize: 10, background: '#3a3020', color: '#c8b48a', padding: '3px 10px', borderRadius: 10, alignSelf: 'flex-start', marginBottom: 12, letterSpacing: '0.06em' },
  tierName: { fontSize: 18, fontWeight: 500, color: '#c8b48a', marginBottom: 4 },
  tierTagline: { fontSize: 12, color: '#7a7888', marginBottom: 18, lineHeight: 1.5 },
  tierPrice: { fontSize: 32, fontWeight: 500, color: '#d4ccc0', marginBottom: 4 },
  tierPriceSub: { fontSize: 11, color: '#7a7888', marginBottom: 4 },
  tierPriceAed: { fontSize: 12, color: '#3a3020', background: '#1a1810', border: '0.5px solid #2a2010', borderRadius: 5, padding: '3px 8px', display: 'inline-block', marginBottom: 16 },
  divider: { height: '0.5px', background: '#1c1c30', margin: '16px 0' },
  featureList: { flex: 1, marginBottom: 20 },
  feature: { display: 'flex', gap: 8, marginBottom: 8, fontSize: 12, color: '#d4ccc0', lineHeight: 1.5 },
  featureNo: { display: 'flex', gap: 8, marginBottom: 8, fontSize: 12, color: '#32303e', lineHeight: 1.5 },
  checkIcon: { flexShrink: 0, marginTop: 1 },
  selectBtn: { width: '100%', padding: '11px', borderRadius: 8, fontSize: 13, fontWeight: 500, cursor: 'pointer', border: 'none', transition: 'opacity 0.15s' },
  formSection: { maxWidth: 560, margin: '0 auto', padding: '0 24px 60px' },
  formTitle: { fontSize: 20, fontWeight: 500, color: '#d4ccc0', marginBottom: 6 },
  formSub: { fontSize: 13, color: '#7a7888', marginBottom: 28, lineHeight: 1.6 },
  selectedTierBadge: { display: 'inline-flex', alignItems: 'center', gap: 8, background: '#1a1810', border: '0.5px solid #c8b48a', borderRadius: 8, padding: '8px 14px', marginBottom: 24 },
  grid2: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14, marginBottom: 14 },
  field: { marginBottom: 14 },
  label: { fontSize: 11, color: '#32303e', letterSpacing: '0.06em', marginBottom: 5, display: 'block' },
  input: { background: '#111120', border: '0.5px solid #1c1c30', color: '#d4ccc0', fontFamily: 'inherit', fontSize: 13, borderRadius: 8, padding: '10px 14px', outline: 'none', width: '100%' },
  select: { background: '#111120', border: '0.5px solid #1c1c30', color: '#d4ccc0', fontFamily: 'inherit', fontSize: 13, borderRadius: 8, padding: '10px 14px', outline: 'none', width: '100%' },
  promoRow: { display: 'flex', gap: 8, marginBottom: 14 },
  promoBtn: { background: '#1c1c30', color: '#c8b48a', border: '0.5px solid #1c1c30', borderRadius: 8, padding: '0 16px', fontSize: 12, cursor: 'pointer', flexShrink: 0 },
  promoSuccess: { fontSize: 12, color: '#608040', background: '#1a2a10', border: '0.5px solid #608040', borderRadius: 6, padding: '8px 12px', marginBottom: 12 },
  promoError: { fontSize: 12, color: '#c05040', background: '#1e0f0f', borderRadius: 6, padding: '8px 12px', marginBottom: 12 },
  submitBtn: { width: '100%', background: '#c8b48a', color: '#08080f', border: 'none', borderRadius: 10, padding: '14px', fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 8 },
  terms: { fontSize: 11, color: '#32303e', textAlign: 'center', marginTop: 14, lineHeight: 1.6 },
  err: { fontSize: 12, color: '#c05040', background: '#1e0f0f', padding: '10px 14px', borderRadius: 8, marginBottom: 14 },
  success: { textAlign: 'center', padding: '48px 24px' },
  successIcon: { width: 64, height: 64, borderRadius: '50%', background: '#1a2a10', border: '0.5px solid #608040', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' },
  successTitle: { fontSize: 22, fontWeight: 500, color: '#d4ccc0', marginBottom: 10 },
  successSub: { fontSize: 14, color: '#7a7888', lineHeight: 1.7, maxWidth: 400, margin: '0 auto' },
};

function CheckIcon({ yes }) {
  if (yes) return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={s.checkIcon}>
      <path d="M12 2L4 5.5V11c0 4.97 3.45 9.61 8 11 4.55-1.39 8-6.03 8-11V5.5L12 2z" fill="#c8b48a" opacity="0.15" stroke="#c8b48a" strokeWidth="1.5"/>
      <path d="M8.5 12.5L11 15L15.5 9.5" stroke="#c8b48a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={s.checkIcon}>
      <circle cx="12" cy="12" r="9" stroke="#32303e" strokeWidth="1.5"/>
      <path d="M15 9l-6 6M9 9l6 6" stroke="#32303e" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

export default function Signup({ onLogin }) {
  const [billing, setBilling] = useState('monthly');
  const [selectedTier, setSelectedTier] = useState(null);
  const [step, setStep] = useState('pricing'); // pricing | form | success
  const [form, setForm] = useState({ name: '', email: '', role: '', company: '', sector: '', notes: '', social_linkedin: '', social_twitter: '', social_instagram: '', promo_code: '' });
  const [promoStatus, setPromoStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [signupResult, setSignupResult] = useState(null);

  const f = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const validatePromo = async () => {
    if (!form.promo_code.trim()) return;
    try {
      const res = await fetch(`${API}/promo/validate`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ code: form.promo_code }) });
      const data = await res.json();
      setPromoStatus(data);
    } catch { setPromoStatus({ valid: false, error: 'Could not validate code' }); }
  };

  const handleSubmit = async () => {
    if (!form.name || !form.email || !form.role || !form.company || !form.sector) { setError('Please fill in all required fields'); return; }
    setLoading(true); setError('');
    try {
      const social = {};
      if (form.social_linkedin) social.linkedin = form.social_linkedin;
      if (form.social_twitter) social.twitter = form.social_twitter;
      if (form.social_instagram) social.instagram = form.social_instagram;

      const res = await fetch(`${API}/signup`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: form.name, email: form.email, role: form.role,
          company: form.company, sector: form.sector,
          tier: selectedTier, billing,
          emails_to_monitor: [form.email],
          social_usernames: social,
          promo_code: form.promo_code || null,
          notes: form.notes,
        })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || 'Signup failed');
      setSignupResult(data);
      setStep('success');
    } catch (e) { setError(e.message); }
    finally { setLoading(false); }
  };

  const price = (tier, curr) => {
    const t = TIERS.find(t => t.id === tier);
    if (!t) return '';
    const usd = billing === 'monthly' ? t.monthly_usd : Math.round(t.annual_usd / 12);
    return curr === 'aed' ? `AED ${Math.round(usd * USD_TO_AED).toLocaleString()}` : `$${usd}`;
  };

  if (step === 'success') return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.logo}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2L4 5.5V11c0 4.97 3.45 9.61 8 11 4.55-1.39 8-6.03 8-11V5.5L12 2z" fill="#c8b48a" opacity="0.2" stroke="#c8b48a" strokeWidth="1.5"/><path d="M8.5 12.5L11 15L15.5 9.5" stroke="#c8b48a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          SHAHEEN
        </div>
      </div>
      <div style={s.success}>
        <div style={s.successIcon}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#608040" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        </div>
        <div style={s.successTitle}>Application received</div>
        <div style={s.successSub}>
          Your application reference is <strong style={{ color: '#c8b48a' }}>{signupResult?.signup_id}</strong>.<br /><br />
          Your advisor will review your application and activate your account within 24 hours. You will receive an email at <strong style={{ color: '#d4ccc0' }}>{form.email}</strong> with your portal access details.
        </div>
        <button style={{ ...s.submitBtn, marginTop: 28, maxWidth: 280, margin: '28px auto 0', display: 'block' }} onClick={() => onLogin && onLogin()}>
          Return to sign in
        </button>
      </div>
    </div>
  );

  if (step === 'form') return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.logo}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2L4 5.5V11c0 4.97 3.45 9.61 8 11 4.55-1.39 8-6.03 8-11V5.5L12 2z" fill="#c8b48a" opacity="0.2" stroke="#c8b48a" strokeWidth="1.5"/><path d="M8.5 12.5L11 15L15.5 9.5" stroke="#c8b48a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          SHAHEEN
        </div>
        <button style={s.loginLink} onClick={() => setStep('pricing')}>← Back to plans</button>
      </div>
      <div style={s.formSection}>
        <div style={{ height: 40 }} />
        <div style={s.formTitle}>Complete your application</div>
        <div style={s.formSub}>Fill in your details below. Your account will be activated within 24 hours after review.</div>

        <div style={s.selectedTierBadge}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M12 2L4 5.5V11c0 4.97 3.45 9.61 8 11 4.55-1.39 8-6.03 8-11V5.5L12 2z" fill="#c8b48a" opacity="0.3" stroke="#c8b48a" strokeWidth="1.5"/></svg>
          <span style={{ fontSize: 13, color: '#c8b48a', fontWeight: 500 }}>{TIERS.find(t => t.id === selectedTier)?.name} plan</span>
          <span style={{ fontSize: 12, color: '#7a7888' }}>{price(selectedTier, 'usd')}/mo · {price(selectedTier, 'aed')}/mo</span>
          <span style={{ fontSize: 11, color: '#7a7888' }}>· {billing}</span>
        </div>

        <div style={s.grid2}>
          <div><span style={s.label}>FULL NAME *</span><input style={s.input} value={form.name} onChange={e => f('name', e.target.value)} placeholder="Ahmed Al-Rashidi" /></div>
          <div><span style={s.label}>WORK EMAIL *</span><input style={s.input} type="email" value={form.email} onChange={e => f('email', e.target.value)} placeholder="ahmed@company.com" /></div>
        </div>
        <div style={s.grid2}>
          <div><span style={s.label}>ROLE / TITLE *</span><input style={s.input} value={form.role} onChange={e => f('role', e.target.value)} placeholder="CEO" /></div>
          <div><span style={s.label}>COMPANY *</span><input style={s.input} value={form.company} onChange={e => f('company', e.target.value)} placeholder="Acme Corp" /></div>
        </div>
        <div style={s.field}>
          <span style={s.label}>SECTOR *</span>
          <select style={s.select} value={form.sector} onChange={e => f('sector', e.target.value)}>
            <option value="">Select your sector</option>
            {SECTORS.map(s => <option key={s} value={s.toLowerCase()}>{s}</option>)}
          </select>
        </div>

        <div style={{ height: '0.5px', background: '#1c1c30', margin: '20px 0' }} />
        <div style={{ fontSize: 11, color: '#7a7888', letterSpacing: '0.06em', marginBottom: 12 }}>SOCIAL MEDIA (optional — for impersonation monitoring)</div>
        <div style={s.grid2}>
          <div><span style={s.label}>LINKEDIN USERNAME</span><input style={s.input} value={form.social_linkedin} onChange={e => f('social_linkedin', e.target.value)} placeholder="ahmedalrashidi" /></div>
          <div><span style={s.label}>TWITTER / X USERNAME</span><input style={s.input} value={form.social_twitter} onChange={e => f('social_twitter', e.target.value)} placeholder="@ahmedceo" /></div>
        </div>
        <div style={s.field}>
          <span style={s.label}>INSTAGRAM USERNAME</span>
          <input style={s.input} value={form.social_instagram} onChange={e => f('social_instagram', e.target.value)} placeholder="@ahmedceo" />
        </div>

        <div style={{ height: '0.5px', background: '#1c1c30', margin: '20px 0' }} />
        <div style={s.field}>
          <span style={s.label}>PROMO CODE (optional)</span>
          <div style={s.promoRow}>
            <input style={s.input} value={form.promo_code} onChange={e => { f('promo_code', e.target.value.toUpperCase()); setPromoStatus(null); }} placeholder="Enter promo code" />
            <button style={s.promoBtn} onClick={validatePromo}>Apply</button>
          </div>
          {promoStatus?.valid && <div style={s.promoSuccess}>✓ {promoStatus.description}</div>}
          {promoStatus?.valid === false && <div style={s.promoError}>{promoStatus.error}</div>}
        </div>

        <div style={s.field}>
          <span style={s.label}>ANYTHING ELSE WE SHOULD KNOW? (optional)</span>
          <textarea style={{ ...s.input, minHeight: 80, resize: 'none' }} value={form.notes} onChange={e => f('notes', e.target.value)} placeholder="Prior incidents, specific concerns, family members to protect..." />
        </div>

        {error && <div style={s.err}>{error}</div>}
        <button style={s.submitBtn} onClick={handleSubmit} disabled={loading}>
          {loading ? 'Submitting...' : 'Submit application'}
        </button>
        <div style={s.terms}>By submitting you agree to Shaheen's service agreement and privacy policy.<br />Your account will be reviewed and activated within 24 hours.</div>
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <div style={s.header}>
        <div style={s.logo}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M12 2L4 5.5V11c0 4.97 3.45 9.61 8 11 4.55-1.39 8-6.03 8-11V5.5L12 2z" fill="#c8b48a" opacity="0.2" stroke="#c8b48a" strokeWidth="1.5"/><path d="M8.5 12.5L11 15L15.5 9.5" stroke="#c8b48a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          SHAHEEN
        </div>
        <button style={s.loginLink} onClick={() => onLogin && onLogin()}>Sign in</button>
      </div>

      <div style={s.hero}>
        <div style={s.heroTitle}>Personal cybersecurity for executives</div>
        <div style={s.heroSub}>Choose your protection tier. Your advisor reviews your application and activates your account within 24 hours.</div>
        <div style={s.billingToggle}>
          <button style={{ ...s.toggleBtn, background: billing === 'monthly' ? '#c8b48a' : 'transparent', color: billing === 'monthly' ? '#08080f' : '#7a7888', borderColor: billing === 'monthly' ? '#c8b48a' : '#1c1c30' }} onClick={() => setBilling('monthly')}>Monthly</button>
          <button style={{ ...s.toggleBtn, background: billing === 'annual' ? '#c8b48a' : 'transparent', color: billing === 'annual' ? '#08080f' : '#7a7888', borderColor: billing === 'annual' ? '#c8b48a' : '#1c1c30' }} onClick={() => setBilling('annual')}>
            Annual <span style={s.saveBadge}>2 months free</span>
          </button>
        </div>
      </div>

      <div style={s.tiers}>
        {TIERS.map(tier => {
          const usdPrice = billing === 'monthly' ? tier.monthly_usd : Math.round(tier.annual_usd / 12);
          const aedPrice = Math.round(usdPrice * USD_TO_AED);
          return (
            <div key={tier.id} style={{ ...s.tierCard, ...(tier.popular ? s.tierCardPop : {}) }}>
              {tier.popular && <div style={s.popularBadge}>MOST POPULAR</div>}
              <div style={s.tierName}>{tier.name}</div>
              <div style={s.tierTagline}>{tier.tagline}</div>
              <div style={s.tierPrice}>${usdPrice}<span style={{ fontSize: 14, fontWeight: 400, color: '#7a7888' }}>/mo</span></div>
              {billing === 'annual' && <div style={s.tierPriceSub}>Billed ${tier.annual_usd.toLocaleString()}/year</div>}
              <div style={s.tierPriceAed}>AED {aedPrice.toLocaleString()}/mo</div>
              <div style={s.divider} />
              <div style={s.featureList}>
                {tier.features.map((f, i) => (
                  <div key={i} style={s.feature}><CheckIcon yes={true} /><span>{f}</span></div>
                ))}
                {tier.notIncluded.map((f, i) => (
                  <div key={i} style={s.featureNo}><CheckIcon yes={false} /><span>{f}</span></div>
                ))}
              </div>
              <button
                style={{ ...s.selectBtn, background: tier.popular ? '#c8b48a' : 'transparent', color: tier.popular ? '#08080f' : '#c8b48a', border: `0.5px solid ${tier.popular ? '#c8b48a' : '#3a3020'}` }}
                onClick={() => { setSelectedTier(tier.id); setStep('form'); }}>
                Select {tier.name}
              </button>
            </div>
          );
        })}
      </div>

      <div style={{ textAlign: 'center', padding: '0 24px 48px', color: '#32303e', fontSize: 12 }}>
        All plans include a 7-day review period. No payment collected until your account is activated.<br />
        Have a promo code? Enter it on the next screen.
      </div>
    </div>
  );
}
